import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useSnackBar } from '@sbv-clients/ui-shared';
import { getApiErrorMessage } from '@sbv-clients/util-misc';

import { AdminCacheKeys, useApi } from '../index';
import { AdminApiAdminConfigFacilityIdPutRequest } from '../lib/api/admin-api';

export const useAdminDashboardGet = () => {
  const api = useApi();
  return useQuery({
    queryKey: [AdminCacheKeys.AdminFacilityDashboard],
    queryFn: () =>
      api.adminApi.adminDashboardGet({}).then((response) => response?.data),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export const useAdminConfigGet = ({ facilityId }: { facilityId: string }) => {
  const api = useApi();
  return useQuery({
    queryKey: [AdminCacheKeys.AdminFacilityConfig, facilityId],
    queryFn: () =>
      api.adminApi
        .adminConfigFacilityIdGet({ facilityId })
        .then((response) => response?.data),
    refetchOnWindowFocus: false,
    enabled: !!facilityId,
  });
};

export const useAdminConfigPut = () => {
  const api = useApi();
  const { notifySuccess, notifyError } = useSnackBar();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (requestParameters: AdminApiAdminConfigFacilityIdPutRequest) =>
      api.adminApi.adminConfigFacilityIdPut(requestParameters),
    onSuccess: async (_, { facilityId }) => {
      queryClient.invalidateQueries([
        AdminCacheKeys.AdminFacilityConfig,
        facilityId,
      ]);
      notifySuccess('Updated successfully');
    },
    onError: (error) => {
      notifyError(getApiErrorMessage(error));
    },
  });
};
